import React, { useState, useEffect } from "react";
import InputMask from "react-input-mask";
import DocumentCode from "./DocumentCode";

import "./Email.scss";
import definition from "~/config";
import api from "~/services/api";
import Loading from "~/components/Loading";
import ButtonSecondary from "../Button/ButtonSecondary";
import ButtonPrimary from "../Button/ButtonPrimary";
import { validateCPF_CNPJ } from '~/services/utils'

export default function Document({ companyToken, fetchMe, onHide, handleLoginByGuest }) {
  const [document, setDocument] = useState("");
  const [documentCode, setDocumentCode] = useState(false);
  const [reset, setReset] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [isCPF, setIsCPF] = useState(true);
  const [documentNotValid, setDocumentNotValid] = useState(null)

  useEffect(() => {
    if (reset) {
      setDocument("");
      setDocumentCode(false);
      setDocumentNotValid(null)
    }
  }, [reset]);

  function handleDocumentChange(event) {
    const document = event.target.value.replace(/\D/g, "");
    document.length >= 12 ? setIsCPF(false) : setIsCPF(true);
    setDocument(document);
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const { valid } = validateCPF_CNPJ(document)

    if (!valid) {
      setDocumentNotValid(true)
      return
    }

    if (definition.accessCodeByEmail) {
      setSubmitting(true);
      try {
        await api.post(`/v1/livestreams/login`, {
          document_number: document
        });
      } catch (e) {
        alert("Não conseguimos validar seus dados de acesso, tente novamente!");
        setReset(true);
        setSubmitting(false);
        return;
      }
    }
    setDocument(document)
    setReset(false);
    setDocumentCode(true);
  }

  return (
    <>
      {(documentCode || companyToken) ? (
        <DocumentCode
          companyToken={companyToken}
          document={document}
          setReset={setReset}
          fetchMe={fetchMe}
          onHide={onHide}
          handleLoginByGuest={handleLoginByGuest}
        />
      ) : (
        <div className="login-email">
          <div className="text">
            <h1>Acessar com documento</h1>
            <p>Insira seu CPF/CNPJ</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor="document">Documento</label>
              <InputMask
                id="document"
                name="document"
                type="text"
                value={document}
                mask={isCPF ? "999.999.999-999" : "99.999.999/9999-99"}
                maskPlaceholder={" "}
                maskChar={null}
                onChange={handleDocumentChange}
                autoFocus
                required
              />
              {documentNotValid && (
                <div className="input-error">Seu CPF ou CNPJ está incorreto.</div>
              )}
            </div>

            <div className="actions">
              {submitting ? (
                <Loading size={5} />
              ) : (
                <>
                  <ButtonSecondary type="button" onClick={onHide}>
                    Voltar
                  </ButtonSecondary>
                  <ButtonPrimary>Próximo</ButtonPrimary>
                </>
              )}
            </div>
          </form>
        </div>
      )}
    </>
  );
}
